(function () {
  'use strict';

  function setSelectedGrade(section, trigger) {
    var popup = document.getElementById('price-request');
    var grade = trigger.getAttribute('data-grade');

    if (!popup || !grade) return;

    var hiddenField = popup.querySelector('#DamderSelectedGrade');
    var selectedGrade = popup.querySelector('.selected-grade');
    var prefix = section.getAttribute('data-quote-prefix') || 'Selected grade: ';

    if (hiddenField) hiddenField.value = grade;
    if (selectedGrade) {
      selectedGrade.textContent = prefix + grade;
      selectedGrade.style.display = 'block';
    }
  }

  function homeSlidesToShow() {
    if (window.innerWidth < 680) return 1;
    return 3;
  }

  function isSliderSection(section) {
    return !!section && (section.classList.contains('damder-etrogim-catalog--home') || section.classList.contains('damder-etrogim-catalog--page'));
  }

  function syncHomeSlider(section) {
    if (!isSliderSection(section)) return;

    var grid = section.querySelector('.damder-etrogim-catalog__grid');
    var $ = window.jQuery;
    var slidesToShow = homeSlidesToShow();

    if (!grid || !$ || !$.fn || typeof $.fn.slick !== 'function' || !$(grid).hasClass('slick-initialized')) return;
    if (Number(grid.getAttribute('data-damder-slides-to-show')) === slidesToShow) return;

    grid.setAttribute('data-damder-slides-to-show', String(slidesToShow));
    $(grid).slick('slickSetOption', {
      slidesToShow: slidesToShow,
      slidesToScroll: 1
    }, true);
    $(grid).slick('setPosition');
  }

  function initHomeSlider(section) {
    if (!isSliderSection(section)) return;
    if (section.getAttribute('data-home-slider-ready') === 'true') return;

    var grid = section.querySelector('.damder-etrogim-catalog__grid');
    var $ = window.jQuery;

    if (!grid || !$ || !$.fn || typeof $.fn.slick !== 'function') return;

    var isHebrew = section.getAttribute('dir') === 'rtl';
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var previousLabel = isHebrew ? 'הקודם' : 'Previous etrog grades';
    var nextLabel = isHebrew ? 'הבא' : 'Next etrog grades';

    section.setAttribute('data-home-slider-ready', 'true');
    $(grid).slick({
      accessibility: true,
      adaptiveHeight: false,
      arrows: true,
      autoplay: !reduceMotion,
      autoplaySpeed: 3600,
      dots: false,
      infinite: true,
      rows: 0,
      rtl: isHebrew,
      slidesToScroll: 1,
      slidesToShow: homeSlidesToShow(),
      pauseOnFocus: true,
      pauseOnHover: true,
      speed: 560,
      swipeToSlide: true,
      touchThreshold: 12,
      waitForAnimate: false,
      prevArrow: '<button class="damder-etrogim-slider__arrow damder-etrogim-slider__arrow--prev" type="button" aria-label="' + previousLabel + '"><span aria-hidden="true">‹</span></button>',
      nextArrow: '<button class="damder-etrogim-slider__arrow damder-etrogim-slider__arrow--next" type="button" aria-label="' + nextLabel + '"><span aria-hidden="true">›</span></button>',
      responsive: [
        {
          breakpoint: 680,
          settings: { slidesToShow: 1, slidesToScroll: 1 }
        }
      ]
    });

    syncHomeSlider(section);
  }

  function initCatalog(section) {
    if (!section || section.getAttribute('data-catalog-ready') === 'true') return;

    section.setAttribute('data-catalog-ready', 'true');

    initHomeSlider(section);

    var cards = section.querySelectorAll('.damder-etrogim-card');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!reduceMotion && 'IntersectionObserver' in window) {
      section.classList.add('is-enhanced');

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
          window.setTimeout(function () {
            entry.target.style.transitionDelay = '';
          }, 650);
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -5% 0px' });

      cards.forEach(function (card, index) {
        card.style.transitionDelay = Math.min(index * 70, 280) + 'ms';
        observer.observe(card);
      });
    } else {
      cards.forEach(function (card) { card.classList.add('is-visible'); });
    }

    // Safety net for carousels: slick clones slides for the infinite loop, and the
    // IntersectionObserver never fires for clones (or off-track originals), leaving
    // them at opacity:0 — an invisible slider. Reveal every card (incl. clones),
    // re-querying a few times to catch clones slick creates asynchronously / on resize.
    if (isSliderSection(section)) {
      var revealAllCards = function () {
        section.querySelectorAll('.damder-etrogim-card').forEach(function (card) {
          card.classList.add('is-visible');
        });
      };
      revealAllCards();
      window.setTimeout(revealAllCards, 400);
      window.setTimeout(revealAllCards, 1200);
    }

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-damder-grade-quote]');
      if (!trigger || !section.contains(trigger)) return;
      setSelectedGrade(section, trigger);
    });
  }

  function initAllCatalogs(root) {
    (root || document).querySelectorAll('[data-damder-etrogim-catalog]').forEach(initCatalog);
  }

  function initQuoteForm(root) {
    if (!root || root.getAttribute('data-quote-ready') === 'true') return;

    var form = root.closest('form');
    if (!form) return;

    root.setAttribute('data-quote-ready', 'true');

    var email = form.querySelector('[data-damder-quote-email]');
    var phone = form.querySelector('[data-damder-quote-phone]');
    var methods = form.querySelectorAll('[data-damder-quote-method]');
    var quantities = Array.prototype.slice.call(form.querySelectorAll('[data-damder-catalog-quantity]'));
    var quantityError = root.getAttribute('data-quantity-error') || 'Enter at least one quantity.';

    function updateRequiredContact(shouldFocus) {
      var selected = form.querySelector('[data-damder-quote-method]:checked');
      var byPhone = selected && selected.value === 'phone';
      var target = byPhone ? phone : email;

      if (email) {
        email.required = !byPhone;
        email.setAttribute('aria-required', byPhone ? 'false' : 'true');
      }
      if (phone) {
        phone.required = true;
        phone.setAttribute('aria-required', 'true');
      }

      if (shouldFocus && target) {
        window.setTimeout(function () { target.focus(); }, 80);
      }
    }

    function validateQuantities() {
      if (!quantities.length) return true;
      var hasQuantity = quantities.some(function (input) { return Number(input.value) > 0; });
      quantities[0].setCustomValidity(hasQuantity ? '' : quantityError);
      return hasQuantity;
    }

    methods.forEach(function (method) {
      method.addEventListener('change', function () { updateRequiredContact(true); });
    });
    quantities.forEach(function (input) { input.addEventListener('input', validateQuantities); });
    form.addEventListener('submit', function (event) {
      if (validateQuantities()) return;
      event.preventDefault();
      if (quantities[0]) quantities[0].reportValidity();
    });
    updateRequiredContact(false);
    validateQuantities();
  }

  function initAllQuoteForms(root) {
    (root || document).querySelectorAll('[data-damder-catalog-quote-form]').forEach(initQuoteForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllCatalogs(document);
      initAllQuoteForms(document);
    });
  } else {
    initAllCatalogs(document);
    initAllQuoteForms(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllCatalogs(event.target);
    initAllQuoteForms(event.target);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('.damder-etrogim-catalog--home, .damder-etrogim-catalog--page').forEach(syncHomeSlider);
    }, 120);
  });

  window.addEventListener('orientationchange', function () {
    window.setTimeout(function () {
      document.querySelectorAll('.damder-etrogim-catalog--home, .damder-etrogim-catalog--page').forEach(syncHomeSlider);
    }, 180);
  });
})();
